import { Icon, type IconProps } from "@chakra-ui/icon";

function TicketIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				opacity="0.4"
				d="M6.66669 5.83333V5.16667M6.66669 8.83333V8.16667M6.66669 11.8333V11.1667"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.5333 3.16667H3.46665C2.71991 3.16667 2.34654 3.16667 2.06133 3.31199C1.81044 3.43982 1.60647 3.6438 1.47864 3.89468C1.33331 4.1799 1.33331 4.55326 1.33331 5.3V6.16667C2.62198 6.16667 3.66665 7.21134 3.66665 8.5C3.66665 9.78867 2.62198 10.8333 1.33331 10.8333V11.7C1.33331 12.4467 1.33331 12.8201 1.47864 13.1053C1.60647 13.3562 1.81044 13.5602 2.06133 13.688C2.34654 13.8333 2.71991 13.8333 3.46665 13.8333H12.5333C13.28 13.8333 13.6534 13.8333 13.9386 13.688C14.1895 13.5602 14.3935 13.3562 14.5213 13.1053C14.6666 12.8201 14.6666 12.4467 14.6666 11.7V10.8333C13.378 10.8333 12.3333 9.78867 12.3333 8.5C12.3333 7.21134 13.378 6.16667 14.6666 6.16667V5.3C14.6666 4.55326 14.6666 4.1799 14.5213 3.89468C14.3935 3.6438 14.1895 3.43982 13.9386 3.31199C13.6534 3.16667 13.28 3.16667 12.5333 3.16667Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default TicketIcon;
